import { formatarPreco } from './formatar.js';
/** Mensagens fixas dos botões que não são de um produto específico. */
export const MENSAGENS = {
    duvida: 'Olá, vim pelo site e gostaria de tirar uma dúvida.',
    atendimento: 'Olá, vim pelo site e gostaria de atendimento.',
    avaliarBike: 'Olá, gostaria de avaliar minha bicicleta usada para venda/troca.',
};
/**
 * Monta a mensagem de interesse num produto.
 *
 * `url` é opcional e, quando presente, entra numa segunda linha. Sem ela o
 * lojista recebe só o nome e precisa procurar a bike no painel; com ela, é um
 * toque. O texto da primeira linha continua idêntico ao do protótipo.
 */
export function mensagemInteresse(produto, url) {
    const preco = formatarPreco(produto.precoCentavos);
    const base = produto.condicao === 'NOVA'
        ? `Olá, tenho interesse na bicicleta nova: ${produto.nome} no valor de ${preco}.`
        : `Olá, tenho interesse na bicicleta USADA: ${produto.nome} por ${preco}.`;
    return url ? `${base}\n${url}` : base;
}
/**
 * `https://wa.me/<numero>?text=<mensagem>`
 *
 * `numero` deve ser só dígitos com DDI (ex.: 556239423988) — o contrato zod de
 * configuração garante o formato. Qualquer não-dígito é removido aqui como
 * segunda linha de defesa, porque um número mal formatado quebra o link em
 * silêncio (o WhatsApp abre uma conversa vazia em vez de dar erro).
 */
export function montarLinkWhatsapp(numero, mensagem) {
    const digitos = numero.replace(/\D/g, '');
    return `https://wa.me/${digitos}?text=${encodeURIComponent(mensagem)}`;
}
//# sourceMappingURL=whatsapp.js.map